import { RootState } from "../../redux/reducers";
import { addAdmins, setAdmins } from "../../redux/slices/adminSlice";
import { store } from "../../redux/store";
import { Admin, CommunityRole } from "../../types/community";
import httpService from "../httpService";

const membersService = {

  makeAdminById: async (memberIds: number[], communityId?: number): Promise<void> => {
    const resolved = communityId ?? (store.getState() as RootState).application.selectedCommunity;
    const promises = memberIds.map(memberId =>
      httpService.put(`/networks/communities/${resolved}/members/${memberId}`, { role: CommunityRole.ADMIN })
    );
    const results = await Promise.all(promises);
    const allData = results.map(result => result.data).flat();
    store.dispatch(addAdmins(allData));
  },

  deleteAdminById: async (memberIds: number[], communityId?: number): Promise<void> => {
    const resolved = communityId ?? (store.getState() as RootState).application.selectedCommunity;
    const promises = memberIds.map(memberId =>
      httpService.put(`/networks/communities/${resolved}/members/${memberId}`, { role: CommunityRole.MEMBER })
    );
    const results = await Promise.all(promises);
    const allData = results.map(result => result.data).flat();
    store.dispatch(addAdmins(allData));
  },

  getAllAdmins: async (communityId?: number): Promise<Admin[]> => {
    const resolved = communityId ?? (store.getState() as RootState).application.selectedCommunity;
    const response = await httpService.get(`/networks/communities/${resolved}/members/admins`);
    store.dispatch(setAdmins(response.data));
    return response.data;
  }

};

export default membersService;
